
if (!customElements.get('product-card-upsell')) {
        customElements.define('product-card-upsell', class ProductCardUpsell extends HTMLElement {
    constructor() {
      super();
  
      this._selectors = {
        addToCart: '[js-upsell-add-to-cart]',
        price: '[js-upsell-price]',
        error: '[js-upsell-error-message]',
        loader: 'loading-spinner',
        cart: 'cart-drawer',
        cartDrawer: '#CartDrawer'
      }
    }
  
    connectedCallback() {
      this.addToCart = this.querySelector(this._selectors.addToCart);
      this.price = this.querySelector(this._selectors.price);
      this.cart = document.querySelector(this._selectors.cart);
      this.cartDrawer = document.querySelector(this._selectors.cartDrawer);
  
      this.addEventListener('variant:change', this._handleVariantChange);
      this.addToCart.addEventListener('click', this._addToCart);
      this.initVariantSelection();
    }
  
    getVariantData() {
        this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('#ProductCardUpsell-VariantData').textContent);
      return this.variantData;
      }

      getOptionsData() {
        this.optionData =
        this.optionData ||
        JSON.parse(this.querySelector('#ProductCardUpsell-OptionsData').textContent);
      return this.optionData;
    }
    


    initVariantSelection() {
        const variantData = this.getVariantData();
        const optionsData = this.getOptionsData();
        this.populateSelectOptions(variantData, optionsData);

        const selects = this.querySelectorAll('select');


        selects.forEach(select => {
          select.addEventListener('change', () => {
              const selectedOptions = Array.from(selects, select => select.value);
              this.updateSelectedVariant(variantData, selectedOptions);
          });
      });      

        const initialSelectedOptions = Array.from(selects, select => select.value);
        this.updateSelectedVariant(variantData, initialSelectedOptions);
    }

    
    populateSelectOptions(variantData, optionsData) {
        let colorOptionIndex = optionsData.indexOf("Color");
        let sizeOptionIndex = optionsData.indexOf("Size");
    
        const availableColors = new Set();
        const availableSizes = new Set();
    
        variantData.forEach(variant => {
            if (variant.available) {
                if (colorOptionIndex !== -1) availableColors.add(variant.options[colorOptionIndex]);
                if (sizeOptionIndex !== -1) availableSizes.add(variant.options[sizeOptionIndex]);
            }
        });
    
        const colorSelect = this.querySelector('select[name="color"]');
        const sizeSelect = this.querySelector('select[name="size"]');
    
        if (colorSelect) {
            colorSelect.innerHTML = '';
            availableColors.forEach(color => {
                colorSelect.add(new Option(color, color));
            });
        }
    
        if (sizeSelect) {
            sizeSelect.innerHTML = '';
            availableSizes.forEach(size => {
                sizeSelect.add(new Option(size, size));
            });
        }
    } 
    
    
    
    
updateSelectedVariant(variantData, selectedOptions) {
    const optionsData = this.getOptionsData(); 

    const selectedOptionsMap = new Map();
    optionsData.forEach((option, index) => {
        const optionValue = selectedOptions[index];
        if (optionValue) {
            selectedOptionsMap.set(option.toLowerCase(), optionValue);
        }
    });

    const matchingVariant = variantData.find(variant => {
        return Array.from(selectedOptionsMap.keys()).every(key => {
            const optionIndex = optionsData.findIndex(option => option.toLowerCase() === key) + 1; 
            const variantOptionValue = variant[`option${optionIndex}`]; 
            return selectedOptionsMap.get(key) === variantOptionValue; 
        });
    });

    if (matchingVariant) {
        this.querySelector('[js-upsell-add-to-cart]').dataset.variantId = matchingVariant.id.toString();
        this._updateAddToCartState(matchingVariant);
        this._updatePrice(matchingVariant);
    } else {
        console.log("No matching variant found for selected options:", Array.from(selectedOptionsMap.values()));
    }
}

    

    
    

    _addToCart = (evt) => {
      evt.preventDefault();
  
      this._disableButton();
  
      this.cart.setActiveElement(document.activeElement);
      const data = {
        items: [{ id: evt.currentTarget.dataset.variantId, quantity: 1 }],
        sections: this.cart.getSectionsToRender().map((section) => section.id)
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
          })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {

          this._handleErrorMessage(response.description);
          return;
        }
        if (document.querySelector('cart-items')) {
          document.querySelector('cart-items').onCartUpdate();
        }
        this.cart.renderContents(response);
          })
          .catch((e) => {        this._handleErrorMessage(e.description)
        console.log(e);
          })
      .finally(() => {
        this._enableButton();
      });
    }
  
    _handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.querySelector(this._selectors.error)
  
      if (errorMessage) {
        this.errorMessageWrapper.innerHTML = errorMessage;
        this.errorMessageWrapper.classList.remove('hidden');
      } else {
        this.errorMessageWrapper.classList.add('hidden');
      }
    }
  
    _disableButton() {
      this.addToCart.setAttribute('disabled', '');
      const loader = this.addToCart.querySelector(this._selectors.loader);
      if (loader) {
        loader.setAttribute('loading', '');
      }
    }
  
    _enableButton() {
      this.addToCart.removeAttribute('disabled');
      const loader = this.addToCart.querySelector(this._selectors.loader);
      if (loader) {
        loader.removeAttribute('loading');
      }
    }
  
    _updateAddToCartState(variant) {
      if (variant) {
        this.addToCart.dataset.variantId = variant.id;
  
        if (variant.available) {
          this.addToCart.textContent = 'ADD TO CART';
          this.addToCart.removeAttribute('disabled');
        } else {
          this.addToCart.textContent = 'SOLD OUT';
          this.addToCart.setAttribute('disabled', '');
        }
      } else {
        this.addToCart.textContent = 'UNAVAILABLE';
        this.addToCart.setAttribute('disabled', '');
      }
    }
  
    _updatePrice(variant) {
        const currencySymbol = window.currency && window.currency.symbol ? window.currency.symbol : "$";
    
        const moneyFormat = `${currencySymbol}{{amount_no_decimals}}`;
    
        if (typeof theme.utils.formatMoney === 'function') {
            this.price.innerHTML = `<span class="product-card-upsell__price">${theme.utils.formatMoney(variant.price, moneyFormat)}</span>${variant.compare_at_price && variant.compare_at_price > variant.price ? `<s class="product-card-upsell__price-compare pl-xs">${theme.utils.formatMoney(variant.compare_at_price, moneyFormat)}</s>` : ''} `;
        } else {
            console.error('theme.utils.formatMoney is not a function. Please check your theme utils.');
        }
    }
    
  
    _handleVariantChange = (evt) => {
      const { variant, priceChange } = evt.detail;
      
      this._handleErrorMessage();
  
      this._updateAddToCartState(variant);
  
      if (variant) {
        if (priceChange) this._updatePrice(variant);
      }
    }
});
}
  